import { useMutation } from '@tanstack/react-query'
import axios from 'services/axios'

export interface ResetPasswordResponse {
  success: boolean
  message: string
  tempPassword: string
}

interface UseResetUserPasswordMutationOptions {
  onSuccess?: (data: ResetPasswordResponse) => void
  onError?: (error: Error) => void
}

export const resetUserPasswordApi = async (userId: string): Promise<ResetPasswordResponse> => {
  const { data } = await axios.put(`users/${userId}/reset-password`)
  return data
}

export const useResetUserPasswordMutation = (options?: UseResetUserPasswordMutationOptions) => {
  const mutation = useMutation({
    mutationFn: resetUserPasswordApi,
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  })

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error ?? null,
    data: mutation.data,
    reset: mutation.reset,
  }
}
